<template>
  <v-btn role="download-all" color="primary" class="ml-1" outlined :disabled="!isDownloadable()" @click="download">
    <v-icon color="primary">mdi-file-download</v-icon>
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue';
import { csvFileName, csvContent, isDownloadable, matrix, MatrixElement } from '@/modules/matrix';
import { downloadTypedStringContent } from '@/services/download';

export default Vue.extend({
  methods: {
    isDownloadable,
    download() {
      matrix.elements.forEach((_element, index) => {
        if (isDownloadable(index)) {
          const fileName = csvFileName(index);
          const fileContent = csvContent(index);
          downloadTypedStringContent(fileName, fileContent, 'text/csv');
        }
      });
    }
  }
});
</script>
